import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import RefreshAds from './RefreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertSidebarAd() {
  const root = document.querySelector(':root');
  const AdCode = app.data['nagusi-ext-ads.ad-code.sidebar'];
  const Script = app.data['nagusi-ext-ads.ad-code.sidebar.js'];
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (areAdsBypassed() || app.current.get('routeName') === 'tags') return;

    // Only show sidebar ad on desktop and tablet
    if (['desktop-hd', 'desktop', 'tablet'].includes(getComputedStyle(root).getPropertyValue('--flarum-screen'))) {
      items.add('nagusi-ext-ads', m("div", {
        class: "nagusi-ad nagusi-ad-sidebar"
      }, Html), -1000);
    }
  });
  extend(IndexPage.prototype, ['oncreate', 'onupdate'], function (returned) {
    if (areAdsBypassed() || app.current.get('routeName') === 'tags' || dev) return;
    RefreshAds();
    safelyEvalAdScript('sidebar', Script);
  });
}